import React from 'react';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { Check } from './Icons';
import { Theme } from '_lib/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    position: 'relative',
    fontFamily: theme.typography.fontFamily,
  },
  label: {
    display: 'flex',
    fontSize: 14,
    fontWeight: 700,
    color: theme.colors.bodyText,
    cursor: 'pointer',
  },
  labelActive: {
    color: theme.colors.primary,
  },
  checkbox: {
    display: 'none',
  },
  checkmark: {
    display: 'flex',
    justifyContent: 'center',
    width: 16,
    height: 16,
    borderRadius: '50%',
    backgroundColor: '#E9E9E9',
  },
  checkmarkActive: {
    backgroundColor: theme.colors.primary,
  },
  contentWrapper: {
    marginLeft: 7,
  },
  checkmarkIcon: {
    fill: '#fff',
  },
}));

type Props = {
  className?: string;
  children: React.ReactNode;
  title: React.ReactNode;
  value?: boolean;
  required: boolean;
  onChange: (value: boolean) => void;
};

const Checkbox = (props: Props) => {
  const {
    className,
    children,
    title,
    onChange,
    value: isChecked = false,
    required,
  } = props;
  const classes = useStyles();

  const checkmarkStyle = cx({
    [classes.checkmark]: true,
    [classes.checkmarkActive]: isChecked,
  });

  const labelStyle = cx({
    [classes.label]: true,
    [classes.labelActive]: isChecked,
  });

  return (
    <div className={cx(classes.container, className)}>
      <label className={labelStyle}>
        <input
          type="checkbox"
          className={classes.checkbox}
          onChange={() => onChange(!isChecked)}
        />
        <div className={checkmarkStyle}>
          <Check
            width={12}
            height={12}
            fill="#fff"
            className={classes.checkmarkIcon}
          />
        </div>
        <span className={classes.contentWrapper}>
          {children || title}
          {required && '*'}
        </span>
      </label>
    </div>
  );
};

export default Checkbox;
